import { Link, useHistory } from "react-router-dom"
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material"
import { Visibility, Warning } from "@mui/icons-material"
import DisciplinaryStatusBadge from "./DisciplinaryStatusBadge"
import styles from "./DisciplinaryCaseTable.module.css"

interface DisciplinaryCase {
  id: string
  caseNumber: string
  employeeId: string
  employeeName: string
  department: string
  issueDate: string
  responseDeadline: string
  responseDate: string
  status: string
  issueType: string
  issue_type: string
  user_id?: string
  date_created?: string
  responseSubmitted: boolean
}

interface DisciplinaryCaseTableProps {
  cases: DisciplinaryCase[]
  loading: boolean
  error: string | null
  isEmployeeView: boolean
  employees: any[]
  setEmployees?: (employees: any[]) => void
}

export default function DisciplinaryCaseTable({ cases, loading, error, isEmployeeView, employees, setEmployees }: DisciplinaryCaseTableProps) {
  const history = useHistory()
  

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <CircularProgress />
        <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
          Loading disciplinary cases...
        </Typography>
      </div>
    )
  }

  if (error) {
    return (
      <Paper className={styles.errorContainer}>
        <Warning color="error" className={styles.errorIcon} />
        <Typography variant="body1" color="error">
          {error}
        </Typography>
      </Paper>
    )
  }

  if (cases?.length === 0) {
    return (
      <Paper className={styles.emptyContainer}>
        <Typography variant="body1" color="textSecondary" gutterBottom>
          No disciplinary cases found.
        </Typography>
        {isEmployeeView ? (
          <Typography variant="body2" color="textSecondary">
            When you receive a disciplinary query, it will appear here.
          </Typography>
        ) : (
          <Button variant="outlined" onClick={() => history.push("/disciplinary/issue")}>
            Issue New Query
          </Button>
        )}
      </Paper>
    )
  }

  return (
    <TableContainer component={Paper}>
      <Table aria-label="disciplinary cases table">
        <TableHead>
          <TableRow>
            <TableCell>Case #</TableCell>
            {!isEmployeeView && <TableCell>Employee Name</TableCell>}
            {/* {!isEmployeeView && <TableCell>Employee</TableCell>} */}
            <TableCell>Issue Type</TableCell>
            <TableCell>Issue Date</TableCell>
            <TableCell>Deadline</TableCell>
            <TableCell>Status</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {cases?.map((item) => {
            const isOverdue =
              item.status === "pending" && !item.responseSubmitted && new Date(item.responseDate) < new Date()

            return (
              <TableRow key={item.id} className={isOverdue ? styles.overdueRow : ""}>
                <TableCell className={styles.caseNumber}>{item.caseNumber || item.id}</TableCell>


                {/* {!isEmployeeView && (
                  <TableCell>
                    <Typography variant="body2">
  {
    employees?.find(
      (emp) =>
        emp?.user_id === item?.employeeId ||
        emp?.user_id === item?.user_id
    )?.uname || item?.employeeName
  }
</Typography>

                  </TableCell>
                )} */}
                {!isEmployeeView && (
                  <TableCell>
                    <div className={styles.employeeCell}>
                      <Typography variant="body2">{item.employeeName}</Typography>
                    
                    </div>
                  </TableCell>
                )}

                <TableCell>{item.issueType || item?.issue_type}</TableCell>
                <TableCell>{new Date(item.issueDate || item?.date_created).toLocaleDateString()}</TableCell>
                <TableCell>
                  <div className={isOverdue ? styles.overdueDate : ""}>
                    {new Date(item.responseDate).toLocaleDateString()}
                  </div>
                  {isOverdue && <div className={styles.overdueLabel}>Overdue</div>}
                </TableCell>
                <TableCell>
                  <DisciplinaryStatusBadge status={item.status} />
                </TableCell>
                <TableCell align="right">
                  <Button
                    component={Link}
                    variant="text"
                    size="small"
                    startIcon={<Visibility />}
                    // onClick={() => history.push(`folder/disciplinary/${item.id}`)}
                    to={
                      {
                        pathname: `/folder/disciplinary`,
                        search: `?id=${item.id}`,
                        state: { item},
                      } as any
                    } // cast to any to bypass TypeScript complaints
                  >
                    View
                  </Button>
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
